/**
 * API Endpoints Configuration
 * Centralized API endpoint management for easy maintenance
 */

const BASE_URL = "https://project.rsaisyiyahsitifatimah.com/api";

export const API_ENDPOINTS = {
  KARYAWAN_JADWAL_HARI_INI: `${BASE_URL}/datapegawai/jadwal-hari-ini`,
  PASIEN_REGISTRASI_HARI_INI: `${BASE_URL}/reg-periksa-hari-ini`,
  CREATE_PENILAIAN: `${BASE_URL}/v1/penilaian/create`,
};

export default API_ENDPOINTS;
